document.addEventListener('DOMContentLoaded', () => {
    // Si existe el contenedor específico, ejecutamos todo
    if (document.getElementById('layer_one_mattress_pure')) {
      
      function updateLayer(id, removeClass, addClass) {
        const el = document.getElementById(id);
        if (!el) return;
        el.classList.remove(removeClass);
        el.classList.add(addClass);
      }
  


    // CAPA 1
    window.i_picker_one_mattress_pure = () => {
        // Mostrar solo el párrafo y borde correcto
        document.querySelectorAll('.labelsTitle').forEach((title, index) => {
          const parent = title.closest('.labelsBorders');
          const paragraph = parent.querySelector('.labelsParagraph');
      
          if (title.textContent.trim() === 'Pure-Sense Cover') {
            parent.classList.add('tw-border-[#6f534b]');
            parent.classList.remove('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-hidden');
            paragraph.classList.add('tw-block');
          } else {
            parent.classList.remove('tw-border-[#6f534b]');
            parent.classList.add('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-block');
            paragraph.classList.add('tw-hidden');
          }
        });
      
        // Mostrar textura 1 y ocultar las demás
        document.querySelectorAll('.materialLayer').forEach(layer => {
          layer.classList.toggle('tw-flex', layer.id === 'materialLayerOne_mattress_pure');
          layer.classList.toggle('tw-hidden', layer.id !== 'materialLayerOne_mattress_pure');
        });
      
        // Mover capa visual principal de regreso
        updateLayer('layer_one_mattress_pure', 'xl:tw-top-[-19px]', 'xl:tw-top-[85px]');
        updateLayer('layer_two_mattress_pure', 'xl:tw-top-[-139px]', 'xl:tw-top-[-11px]');
        updateLayer('layer_three_mattress_pure', 'xl:tw-top-[-263px]', 'xl:tw-top-[-127px]');
  
      };
  
  
      // CAPA 2
      window.i_picker_two_mattress_pure = () => {
        // Mostrar solo el párrafo y borde correcto
        document.querySelectorAll('.labelsTitle').forEach((title, index) => {
          const parent = title.closest('.labelsBorders');
          const paragraph = parent.querySelector('.labelsParagraph');
          
          if (title.textContent.trim() === 'Graphite Memory Foam (2”)') {
            parent.classList.add('tw-border-[#6f534b]');
            parent.classList.remove('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-hidden');
            paragraph.classList.add('tw-block');
          } else {
            parent.classList.remove('tw-border-[#6f534b]');
            parent.classList.add('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-block');
            paragraph.classList.add('tw-hidden');
          }
        });
      
        // Mostrar textura 2 y ocultar las demás
        document.querySelectorAll('.materialLayer').forEach(layer => {
          layer.classList.toggle('tw-flex', layer.id === 'materialLayerTwo_mattress_pure');
          layer.classList.toggle('tw-hidden', layer.id !== 'materialLayerTwo_mattress_pure');
        });
      
        // Mover capa visual principal
        updateLayer('layer_one_mattress_pure', 'xl:tw-top-[85px]', 'xl:tw-top-[-19px]');
        updateLayer('layer_two_mattress_pure', 'xl:tw-top-[-139px]', 'xl:tw-top-[-11px]');
        updateLayer('layer_three_mattress_pure', 'xl:tw-top-[-263px]', 'xl:tw-top-[-127px]');
  
      };
  
  
      // CAPA 3
      window.i_picker_three_mattress_pure = () => {
        document.querySelectorAll('.labelsTitle').forEach((title) => {
          const parent = title.closest('.labelsBorders');
          const paragraph = parent.querySelector('.labelsParagraph');
      
          if (title.textContent.trim() === 'Comfort Foam (1”)') {
            parent.classList.add('tw-border-[#6f534b]');
            parent.classList.remove('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-hidden');
            paragraph.classList.add('tw-block');
          } else {
            parent.classList.remove('tw-border-[#6f534b]');
            parent.classList.add('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-block');
            paragraph.classList.add('tw-hidden');
          }
        });
      
        document.querySelectorAll('.materialLayer').forEach(layer => {
          layer.classList.toggle('tw-flex', layer.id === 'materialLayerThree_mattress_pure');
          layer.classList.toggle('tw-hidden', layer.id !== 'materialLayerThree_mattress_pure');
        });
      
        updateLayer('layer_one_mattress_pure', 'xl:tw-top-[85px]', 'xl:tw-top-[-19px]');
        updateLayer('layer_two_mattress_pure', 'xl:tw-top-[-11px]', 'xl:tw-top-[-139px]');
        updateLayer('layer_three_mattress_pure', 'xl:tw-top-[-263px]', 'xl:tw-top-[-127px]');
  
      };
  
  
      // CAPA 4
      window.i_picker_four_mattress_pure = () => {
        document.querySelectorAll('.labelsTitle').forEach((title) => {
          const parent = title.closest('.labelsBorders');
          const paragraph = parent.querySelector('.labelsParagraph');
      
          if (title.textContent.trim() === 'Flex Support Base (5”)') {
            parent.classList.add('tw-border-[#6f534b]');
            parent.classList.remove('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-hidden');
            paragraph.classList.add('tw-block');
          } else {
            parent.classList.remove('tw-border-[#6f534b]');
            parent.classList.add('tw-border-[#CEC6B9]');
            paragraph.classList.remove('tw-block');
            paragraph.classList.add('tw-hidden');
          }
        });
      
        document.querySelectorAll('.materialLayer').forEach(layer => {
          layer.classList.toggle('tw-flex', layer.id === 'materialLayerFour_mattress_pure');
          layer.classList.toggle('tw-hidden', layer.id !== 'materialLayerFour_mattress_pure');
        });
      
        updateLayer('layer_one_mattress_pure', 'xl:tw-top-[85px]', 'xl:tw-top-[-19px]');
        updateLayer('layer_two_mattress_pure', 'xl:tw-top-[-11px]', 'xl:tw-top-[-139px]');
        updateLayer('layer_three_mattress_pure', 'xl:tw-top-[-127px]', 'xl:tw-top-[-263px]');
  
  
      };


      document.addEventListener('DOMContentLoaded', () => {
        window.i_picker_one_mattress_pure();
      });



    }
});